export default __webpack_public_path__ + "static/accents-mixing-colors-do-light-150767bb253740fb24185d7ad6c61d8f.png";